/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import AssignedToIcon from 'icons/AssignedToIcon';

const messages = defineMessages({
  title: {id: 'navigation.assigned-to'},
});

const AssignedToItem = () => (
  <StudentRouteLinkItem
    iconBefore={AssignedToIcon}
    route="midas/student/assigned-to"
    title={messages.title}
  />
);

export default AssignedToItem;
